import React from 'react';
import { Box } from '@mui/material';

const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', name: 'All Products', image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=200&h=150&fit=crop' },
    { id: 'metabolic', name: 'Blood Sugar Support', image: 'https://images.unsplash.com/photo-1615486511484-92e172cc4fe0?w=200&h=150&fit=crop' },
    { id: 'cardiovascular', name: 'Heart Health', image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=200&h=150&fit=crop' },
    { id: 'immunity', name: 'Immunity Boost', image: 'https://images.unsplash.com/photo-1594737625785-a6cbdabd333c?w=200&h=150&fit=crop' },
    { id: 'digestive', name: 'Gut Health', image: 'https://images.unsplash.com/photo-1505576399279-565b52d4ac71?w=200&h=150&fit=crop' },
    { id: 'detox', name: 'Detox & Repair', image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=200&h=150&fit=crop' }
    // { id: 'premium', name: 'Premium', image: 'https://images.unsplash.com/photo-1622597467836-f3285f2131b8?w=200&h=150&fit=crop' }
  ];

  return (
    <Box sx={{ mb: 3, px: { xs: 0.5, sm: 2 } }}>
      <Box sx={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: { xs: 1, sm: 1.5, md: 2 },
        justifyContent: { xs: 'space-between', md: 'center' }
      }}>
        {categories.map((category) => (
          <Box
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            sx={{
              cursor: 'pointer',
              textAlign: 'center',
              padding: '6px',
              borderRadius: '8px',
              backgroundColor: selectedCategory === category.id ? '#2e7d32' : '#ffffff',
              color: selectedCategory === category.id ? 'white' : '#2e7d32',
              border: selectedCategory === category.id ? '2px solid #2e7d32' : '2px solid #e0e0e0',
              transition: 'all 0.3s ease',
              width: { xs: 'calc(33.333% - 6px)', sm: 'calc(33.333% - 10px)', md: 'auto' },
              minWidth: { xs: 'auto', sm: '120px', md: '140px' },
              maxWidth: { xs: 'none', sm: 'calc(33.333% - 10px)', md: '180px' },
              '&:hover': {
                backgroundColor: selectedCategory === category.id ? '#1b5e20' : '#f5f5f5',
                border: '2px solid #2e7d32',
                transform: 'translateY(-2px)'
              }
            }}
          >
            <Box sx={{ 
              fontWeight: 600,
              fontSize: { xs: '0.75rem', sm: '0.85rem', md: '0.9rem' },
              mb: { xs: 0, sm: 0.5 },
              lineHeight: 1.3,
              minHeight: { xs: 'auto', sm: '32px' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: { xs: 1, sm: 0 }
            }}>
              {category.name}
            </Box>
            <Box
              component="img"
              src={category.image}
              alt={category.name}
              sx={{
                width: '100%',
                height: { xs: '0', sm: '70px', md: '80px' },
                objectFit: 'cover',
                borderRadius: '6px',
                display: { xs: 'none', sm: 'block' }
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CategoryFilter;